import { render, staticRenderFns } from "./UserViewValidatedModal.vue?vue&type=template&id=08f03d56&scoped=true"
import script from "./UserViewValidatedModal.vue?vue&type=script&lang=js"
export * from "./UserViewValidatedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f03d56",
  null
  
)

export default component.exports